import APP from './modules/app';
import SEARCH from './modules/search';
import ANALYSIS from './modules/analysis';
import CONTACTS from './modules/contacts';
import REPORT from './modules/report';
import CLIENT from './modules/client';

export default {
  APP,
  SEARCH,
  ANALYSIS,
  CONTACTS,
  REPORT,
  CLIENT,
}
